import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';

import Html from '~/commons/components/Html.jsx';

const Article = ({
  article,
  children,
}) => {
  const { attachment } = article;

  return (
    <div className="readable">
      <div className="row align-items-center">
        <div className="col">
          <h1 className="h2 mt-3 mb-3 mb-md-4">{article.title}</h1>
        </div>
        {attachment && (
          <div className="col-md-auto">
            <a
              href={attachment.url}
              className="btn btn-outline-secondary mt-md-3 mb-3 mb-md-4"
              download={attachment.originalname}
            >
              <FA icon={faDownload} fixedWidth />
              下載
            </a>
          </div>
        )}
      </div>
      {children}
      <Html>{article.content}</Html>
    </div>
  );
};

export default Article;
